namespace Matrix.Administration {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class UserDialog extends Serenity.EntityDialog<UserRow, any> {
        protected getFormKey() { return UserForm.formKey; }
        protected getIdProperty() { return UserRow.idProperty; }
        protected getLocalTextPrefix() { return UserRow.localTextPrefix; }
        protected getNameProperty() { return UserRow.nameProperty; }
        protected getService() { return UserService.baseUrl; }

        protected form = new UserForm(this.idPrefix);

        constructor() {
            super();

            this.form.Username.element.closest('form').attr('autocomplete', 'false');
            this.form.Username.element.attr('type', 'search').attr('autocomplete', 'new-password');
            this.form.Password.element.attr('autocomplete', 'new-password');

            this.form.Password.addValidationRule(this.uniqueName, e => {
                if (this.form.Password.value.length < 7)
                    return "Password must be at least 7 characters!";

                if (!this.form.Password.value.match(/[^A-Za-z0-9]/))
                    return "Password must have at least one non-alphanumeric character!";

                if (!this.form.Password.value.match(/[A-Z]/))
                    return "Password must have at least one uppercase (A-Z) character!";

                if (!this.form.Password.value.match(/[a-z]/))
                    return "Password must have at least one lowercase (a-z) character!";

                if (!this.form.Password.value.match(/[0-9]/))
                    return "Password must have at least one numeric (0-9) character!";

                return null;
            });

            this.form.PasswordConfirm.addValidationRule(this.uniqueName, e => {
                if (this.form.Password.value != this.form.PasswordConfirm.value)
                    return "The passwords entered doesn't match!";
            });
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();

            // these fields are only required in new record mode
            this.form.Password.element.toggleClass('required', this.isNew())
                .closest('.field').find('sup').toggle(this.isNew());
            this.form.PasswordConfirm.element.toggleClass('required', this.isNew())
                .closest('.field').find('sup').toggle(this.isNew());
        }

        protected updateInterface() {
            super.updateInterface();

            if (!Authorization.userDefinition.CanAddDeleteUsers) {
                this.form.Password.getGridField().hide();
                this.form.PasswordConfirm.getGridField().hide();
                Serenity.EditorUtils.setReadOnly(this.form.Username, true);
                Serenity.EditorUtils.setReadOnly(this.form.Email, true);
                Serenity.EditorUtils.setReadOnly(this.form.RoleNames, true);
                Serenity.EditorUtils.setReadOnly(this.form.ProfileImage, true);
                Serenity.EditorUtils.setReadOnly(this.form.IsActive, true);
                this.toolbar.findButton('delete-button').hide();
                this.toolbar.findButton('apply-changes-button').hide();
                this.toolbar.findButton('save-and-close-button').hide();
            }
        }
    }
}